// A public figure's page (15 October 2026): the page, its header, its career.
export default {
  titre: 'Public figures',
  chargement: 'Loading…',
  entete: {
    retour: 'Public figures',
    nonSuivie: 'Not followed',
    chaqueJour: 'Listened to daily',
    premiere: 'First listening in progress',
    ecouteeCeMatin: 'Listened to daily · last listening today at {heure}',
    ecouteeLe: 'Listened to daily · last listening on {quand} at {heure}',
  },
  onglets: {
    aria: 'Page',
    jour: 'Today',
    citations: 'Quotes',
    personas: 'Who talks about them',
    sonar: 'Sonar',
    zeus: 'Hermès',
    positions: 'Positions and career',
  },
  premiere: {
    titre: 'First listening in progress',
    texte: 'Orion is reading the past week: what was said, by whom, where and when. This page fills itself in within a few minutes.',
  },
  nonSuivie: {
    titre: 'Listen to them every day',
    texte: 'Following this public figure starts a daily listening: what is said, their own words, every quote with its source, who talks about them and how that shifts, their positions topic by topic, and an alert when something moves.',
  },
  parcours: {
    titre: 'Career',
    depuis: 'since {debut}',
    du: 'from {debut} to {fin}',
    enCours: 'current',
    aucun: 'No known mandate.',
    officielle: 'Official page',
    wikidata: 'Wikidata page',
  },
  comptes: {
    titre: 'Accounts',
    declare: 'declared',
    ajoute: 'added',
    aucun: 'No known account: Orion listens to what is said everywhere else.',
  },
}
